import { FunctionComponent } from 'react'
import Modal from '@/components/RebrandedModal'
import { useModalContext } from '@/components/RebrandedModal/contexts/ModalContext'
import ProfileCard from '../../ProfileCard'
import { RenderIf } from '@/components/RenderIf'
import { ISpecialtyResponse } from '@/modules/Auth/auth-types'
import useStyles from './styles'
import { Collapse, Text } from '@conexasaude/conexa-hero'
interface PropsSpecialtiesModal {
  name?: string
  type?: string
  clinic?: string
  photo?: string
  specialities: Record<string, ISpecialtyResponse>
}

const SpecialtiesModal: FunctionComponent<PropsSpecialtiesModal> = ({
  type,
  name,
  clinic,
  photo,
  specialities,
}) => {
  const { closeModal } = useModalContext()
  const styles = useStyles()

  const specialitiesArray = [
    specialities?.socialWorker,
    specialities?.dentist,
    specialities?.nursing,
    specialities?.physiotherapy,
    specialities?.speechTherapist,
    specialities?.nutrition,
    specialities?.psyAlive,
    specialities?.psychology,
  ]
  return (
    <Modal
      id="SPECIALTIES_MODAL"
      primaryActionLabel="Entendi"
      primaryAction={closeModal}
    >
      <div css={styles.modalContainer}>
        <ProfileCard name={name} clinic={clinic} photo={photo} type={type} />
        <Text renderAs="h4">Especialidades disponíveis para você:</Text>
        <section className="row">
          <div css={styles.containerLink}>
            <RenderIf condition={specialities?.medic?.atendimentoImediato}>
              <Collapse title="Atendimento Imediato" variant="secondary">
                <Text variant="paragraphSmall">
                  Você pode realizar consulta imediata com clínico geral, para
                  te ajudar no momento que precisar.
                </Text>
              </Collapse>
            </RenderIf>
            <RenderIf condition={specialities?.medic?.atendimentoAgendado}>
              <Collapse title="Médicos" variant="secondary">
                <Text variant="paragraphSmall">
                  Você pode agendar consultas com clínicos gerais e
                  especialistas, para cuidar da saúde por completo.
                </Text>
              </Collapse>
            </RenderIf>
            {specialitiesArray?.map(speciality => (
              <RenderIf
                key={speciality?.id}
                condition={speciality?.atendimentoAgendado}
              >
                <Collapse
                  title={speciality?.descricaoGeral}
                  variant="secondary"
                >
                  <Text variant="paragraphSmall">
                    {speciality?.descricaoServico}
                  </Text>
                </Collapse>
              </RenderIf>
            ))}
          </div>
        </section>
      </div>
    </Modal>
  )
}

export { SpecialtiesModal }
